export default __webpack_public_path__ + "static/media/aquarelle_bug.b1aec9c4.jpg";